import React, { useState, useEffect, useMemo } from 'react';
import { FaUserTag, FaPaperPlane, FaSearch, FaGift, FaBullhorn, FaTrashAlt, FaHistory } from 'react-icons/fa';
import './CRMManager.css';

const CRMManager = ({ orders = [], docRequests = [] }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [promoData, setPromoData] = useState({ title: "", type: "SERVICIO", link: "", active: false });

    useEffect(() => {
        const savedBanner = localStorage.getItem('globalBanner');
        if (savedBanner) setPromoData(JSON.parse(savedBanner));
    }, []);

    const handlePublishBanner = () => {
        if (!promoData.title.trim()) return alert("Escribe un título.");
        const updated = { ...promoData, active: true };
        localStorage.setItem('globalBanner', JSON.stringify(updated));
        window.dispatchEvent(new Event('bannerUpdated'));
        alert("¡Banner Publicado!");
    };

    const handleClearBanner = () => {
        const cleared = { title: "", type: "SERVICIO", link: "", active: false };
        localStorage.setItem('globalBanner', JSON.stringify(cleared));
        setPromoData(cleared);
        window.dispatchEvent(new Event('bannerUpdated'));
        alert("Banner Desactivado.");
    };

    // Función de envío de correos (MANTENIDA)
    const handleSendPromo = (email, type) => {
        const subject = type === 'libro' ? "Publicación Premium - Dr. Scarvaci" : "Oferta Académica Especial";
        const body = `Hola, hemos actualizado nuestro catálogo de ${type}s. Puedes verlo en la plataforma.`;
        window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };

    const customers = useMemo(() => {
        const clientMap = {};
        orders.forEach(o => {
            const email = (o.customerEmail || "").toLowerCase();
            if (!clientMap[email]) {
                clientMap[email] = { name: o.customerName, email, phone: o.phone || "N/A", total: 0, type: 'Lector', history: [] };
            }
            clientMap[email].total += Number(o.amountUSD || 0);
            clientMap[email].history.push(`Libro: ${o.bookTitle}`);
        });

        docRequests.forEach(d => {
            const email = (d.customerEmail || "").toLowerCase();
            if (!clientMap[email]) {
                clientMap[email] = { name: d.customerName, email, phone: d.phone || "N/A", total: Number(d.priceUSD || 0), type: 'Cliente Legal', history: [`Trámite: ${d.areaLegal || 'Servicio Legal'}`] };
            } else {
                clientMap[email].type = 'VIP (Ambos)';
                clientMap[email].total += Number(d.priceUSD || 0);
                clientMap[email].history.push(`Trámite: ${d.areaLegal || 'Servicio Legal'}`);
            }
        });
        return Object.values(clientMap).sort((a,b) => b.total - a.total);
    }, [orders, docRequests]);

    return (
        <div className="crm-container fade-in">
            {/* PANEL DE BANNER */}
            <div className="promo-config-card">
                <h3><FaBullhorn color="#D4AF37" /> Control Maestro de Anuncios</h3>
                <div className="promo-inputs">
                    <input type="text" placeholder="Título" value={promoData.title} onChange={e => setPromoData({...promoData, title: e.target.value})} />
                    <select value={promoData.type} onChange={e => setPromoData({...promoData, type: e.target.value})}>
                        <option value="LIBRO">Libro</option>
                        <option value="CURSO">Curso Online</option>
                        <option value="SERVICIO">Servicio Legal</option>
                    </select>
                    <input type="text" placeholder="URL Enlace" value={promoData.link} onChange={e => setPromoData({...promoData, link: e.target.value})} />
                    <div style={{display:'flex', gap:'10px', marginTop:'10px'}}>
                        <button className="btn-save-pro" onClick={handlePublishBanner} style={{flex:2}}>Publicar</button>
                        <button onClick={handleClearBanner} style={{flex:1, background:'#ff4d4d', color:'white', border:'none', borderRadius:'8px'}}><FaTrashAlt /></button>
                    </div>
                </div>
            </div>

            <div className="crm-header">
                <h2><FaUserTag /> Base de Datos VIP ({customers.length})</h2>
                <div className="search-box">
                    <FaSearch />
                    <input type="text" placeholder="Buscar cliente..." onChange={e => setSearchTerm(e.target.value)} />
                </div>
            </div>

            <div className="crm-grid">
                {customers.filter(c => c.name.toLowerCase().includes(searchTerm.toLowerCase()) || c.email.toLowerCase().includes(searchTerm.toLowerCase())).map((c, i) => (
                    <div key={i} className="client-card">
                        <div className="client-info">
                            <h4>{c.name}</h4>
                            <p className="client-email">{c.email}</p>
                            <p style={{fontSize: '12px', marginBottom: '10px'}}><b>Tel:</b> {c.phone}</p>
                            <div style={{display:'flex', justifyContent:'space-between', alignItems: 'center'}}>
                                <span className={`tag-${c.type.replace(/\s/g, '')}`}>{c.type}</span>
                                <b style={{color:'#2e7d32'}}>${c.total.toFixed(2)}</b>
                            </div>
                            <div className="client-history" style={{marginTop: '10px', padding: '8px', background: '#f9f9f9', borderRadius: '6px'}}>
                                <small style={{color: '#666', display: 'flex', alignItems: 'center', gap: '5px'}}>
                                    <FaHistory /> {c.history[c.history.length - 1]}
                                </small>
                            </div>
                        </div>
                        <div className="client-actions">
                            <button onClick={() => handleSendPromo(c.email, 'libro')}><FaGift /> Enviar Libro</button>
                            <button onClick={() => handleSendPromo(c.email, 'curso')}><FaPaperPlane /> Enviar Curso</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CRMManager;